import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'sort',
})
export class SortPipe implements PipeTransform {
  transform(array: any, field: string, order?: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    if (field != '') {
      array.sort((a: any, b: any) => {
        let left, right;
        if(typeof a[field] === 'string' && typeof b[field] === 'string') {
          left = a[field].toLowerCase();
          right = b[field].toLowerCase();
        } else {
          left = a[field];
          right = b[field];
        }
        if (left > right) {
          return -1;
        } else if (left < right) {
          return 1;
        } else {
          return 0;
        }
      });
    } else {
      array.sort((a: any, b: any) => {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    if (order === 'asc') {
      return array.reverse();
    }
    return array;
  }
}
